export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10635.30e43b19.jpg";